import React from 'react';
import {Box, Select, FormControl, CheckIcon} from 'native-base';
import {FieldError, useController, UseControllerProps} from 'react-hook-form';
import {message} from '../../../utils/messages';
import IDropDownOption from '../../../interfaces/ui/dropdown-option.interface';
import {defaultProps} from './../constants';
import {isWebApp} from '../../../utils/platform/is-web';

interface Props extends UseControllerProps<any> {
  label: string;
  error?: FieldError | undefined;
  options: IDropDownOption[];
  width?: string;
  isRequired?: boolean;
}

const DropDownInput = (props: Props) => {
  const {
    label,
    error,
    control,
    name,
    rules,
    options,
    width,
    isRequired,
    defaultValue,
  } = props;
  const {field} = useController({
    control,
    defaultValue: defaultValue ?? '',
    name,
    rules,
  });

  const getMessage = (text: string) => {
    return message(text).trim();
  };

  const handleOnValueChange = (itemValue: any) => {
    field.onChange(itemValue);
  };

  const getErrorMessage = () => {
    return error != null ? getMessage(error.message as string) : '';
  };

  const defaultMarginWeb = {
    mr: 1,
    ml: 1,
  };

  const getPropertiesWeb = () => {
    if (isWebApp) {
      return defaultMarginWeb;
    }
    return {};
  };

  return (
    <Box width={width ? width : '100%'} marginBottom={5}>
      <FormControl isInvalid={error != null} isRequired={isRequired ?? true}>
        <FormControl.Label>{getMessage(label)}</FormControl.Label>
        <Select
          optimized={false}
          backgroundColor={'#ffffff'}
          _selectedItem={{
            bg: 'blue.200',
            endIcon: <CheckIcon size="5" color="black" />,
          }}
          mt={1}
          {...defaultProps}
          selectedValue={field.value}
          onValueChange={itemValue => handleOnValueChange(itemValue)}
          fontSize={14}
          defaultValue={defaultValue}
          {...getPropertiesWeb()}>
          {options.map((option, index) => (
            <Select.Item
              key={`option-${index}`}
              label={option.label}
              value={option.value}
            />
          ))}
        </Select>
        <FormControl.ErrorMessage>{getErrorMessage()}</FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

export default DropDownInput;
